import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { UploadMedia, UploadMediaModel } from './UploadMediaModel';
import { MediaTypeEnum } from '@constants';

export class UploadMediaList extends Model({
  list: types.array(UploadMediaModel),
}) {
  get isEmpty() {
    return this.list.length === 0;
  }

  get hasVideo() {
    return this.list.some((i) => i.type === MediaTypeEnum.Video);
  }

  get hasImage() {
    return this.list.some((i) => i.type === MediaTypeEnum.Image);
  }

  get asArray() {
    return this.list.slice();
  }

  get ids() {
    return this.list.map((i) => i.id);
  }

  get canAddMore() {
    if (this.hasVideo) {
      return this.list.length < 1;
    } else if (this.hasImage) {
      return this.list.length < 4;
    } else {
      return true;
    }
  }

  get isAllMediaUploaded() {
    return this.isEmpty ? true : this.list.every((i) => i.isUploaded);
  }

  get dataToUpload() {
    const photoIds = this.list
      .filter((i) => i.type === MediaTypeEnum.Image)
      .map((i) => i.id);

    // User can upload only one video
    const videoId = this.list.find(
      (i) => i.type === MediaTypeEnum.Video,
    )?.id;

    return {
      photoIds,
      videoId,
    };
  }

  add(media: Pick<UploadMedia, 'uri' | 'type'>) {
    this.list.push({ uri: media.uri, type: media.type });
  }

  /**
   * Set already uploaded media
   */
  set(media: Pick<UploadMedia, 'uri' | 'type' | 'id'>[]) {
    this.list.push(
      ...media.map((item) => ({
        uri: item.uri,
        type: item.type,
        id: item.id,
        isUploaded: true,
      })),
    );
  }

  remove(id: string) {
    const item = this.list.find((image) => image.id === id);

    if (item) {
      item.abortUpload();
      this.list.remove(item);
    }
  }

  clear() {
    this.list.clear();
  }
}

export const UploadMediaListModel = model(UploadMediaList);
